import axios from 'axios';
import getSettings from './settings-loader';

const createAxiosInstance = async (options) => {

    const settings = await getSettings();

    if (!settings) {
        console.error('Settings not found. Using default configuration.');
        return axios.create({}); // Use default configuration if settings are not available
    }

    //console.log(window.location.hostname);
    const { apiUrl } = settings[window.location.hostname];
    //console.log(apiUrl);

    const instance = axios.create({
        baseURL: apiUrl, // Replace this with your API base URL
        timeout: 30000, // Set a request timeout in milliseconds (optional)
        headers: {
            'Content-Type': 'application/json; charset=utf8', // Set default headers if needed
        },
    });

    if (options.headers) {
        for (const property in options.headers) {
            instance.defaults.headers.common[property] = options.headers[property];
        }
    }

    instance.interceptors.response.use(
        (response) => {
            // Return the response data if no error
            return response.data;
        },
        (error) => {

            //console.log(error);
            let result = { status: 0, text: "Помилка" };

            if (error) {

                if (error.code && error.code === 'ERR_NETWORK') {
                    result.status = 503;
                    result.text = "Connection to server error (Service Unavailable)";
                }
                else if (error.request) { 
                    result.status = error.request.status;
                    result.text = error.request.responseText;
                }
            }
            
            return Promise.reject(result);
        });

    return instance
};

export default createAxiosInstance;


              //axiosInstance.get('/getAuth', {

        //})
        //    .then(function (response) {
        //        var t = 4;
        //    })
        //    .catch(function (error) {
        //        console.log(error);
        //    })
        //    .finally(function () {
        //        // always executed
        //    });

